// * Código criado com referência em: https://github.com/unlayer/vue-email-editor/blob/master/src/components/loadScript.ts

export default defineNuxtPlugin(() => {
  const defaultScriptUrl = 'https://editor.unlayer.com/embed.js?2'
  const callbacks: (() => void)[] = []
  let loaded = false

  const isScriptInjected = (scriptUrl: string) => {
    return !![...document.querySelectorAll('script')].find((script) =>
      script.src.includes(scriptUrl),
    )
  }

  const addCallback = (callback: () => void) => {
    callbacks.push(callback)
  }

  const runCallbacks = () => {
    while (callbacks.length) {
      const callback = callbacks.shift()
      if (callback) callback()
    }
  }

  const loadScript = (scriptUrl = defaultScriptUrl) => {
    return new Promise<void>((resolve) => {
      addCallback(resolve)

      if (!isScriptInjected(scriptUrl)) {
        const embedScript = document.createElement('script')
        embedScript.setAttribute('src', scriptUrl)
        embedScript.onload = () => {
          loaded = true
          runCallbacks()
        }
        document.head.appendChild(embedScript)
      } else if (loaded) {
        runCallbacks()
      }
    })
  }

  return {
    provide: {
      unlayer: {
        loadScript,
      },
    },
  }
})
